// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4734c3c0","147":"cc54888c","234":"b256b2f6","504":"ca13aba4","615":"09c72469","818":"1b4d1a13","820":"82c65745","996":"edaeb8fe"}[chunkId] + ".chunk.js";
};